<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-image</v-icon>
        <span class="title ml-1">Carrusel</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="showAdd = true">Agregar</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="slides.length">
          <v-col v-for="item in slides" :key="item.id" cols="12" md="6">
            <v-card>
              <v-img :src="item.imagen" height="250px">
                <div
                  class="fill-height d-flex flex-column justify-center align-center"
                  :style="{ background: item.fondo }"
                >
                  <p
                    class="display-2 font-weight-black"
                    :class="[item.is_claro ? 'white--text' : '']"
                  >
                    {{ item.titulo }}
                  </p>
                  <p
                    class="subtitle-1 font-weight-light"
                    :class="[item.is_claro ? 'white--text' : '']"
                  >
                    {{ item.subtitulo }}
                  </p>
                  <v-btn
                    v-if="item.link"
                    :href="item.link"
                    target="_blank"
                    outlined
                    :class="[item.is_claro ? 'white--text' : 'black--text']"
                  >
                    {{ item.link_titulo }}
                  </v-btn>
                </div>
              </v-img>
              <v-card-title>
                <v-btn color="error" @click="deleteSlide(item.id)">
                  <v-icon left>fas fa-trash</v-icon>
                  Borrar
                </v-btn>
                <!-- <v-spacer />
                <v-btn color="secondary">
                  <v-icon left>fas fa-edit</v-icon>
                  Editar
                </v-btn> -->
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-alert v-else type="info" text>
          No hay datos disponibles
        </v-alert>
        <v-pagination v-if="slides.length" v-model="page" :length="pages"></v-pagination>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showAdd" max-width="700px">
      <AddSlide @close="showAdd = false" @saved="refresh"></AddSlide>
    </v-dialog>
  </v-container>
</template>

<script>
import AddSlide from '../components/AddSlide'
import { host } from '../config'
export default {
  data () {
    return {
      slides: [],
      showAdd: false,
      page: 1,
      pages: 1
    }
  },
  components: {
    AddSlide
  },
  async created () {
    await this.getPages()
    await this.getSlides()
  },
  methods: {
    async getPages () {
      const { data } = await this.$http.slides.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getSlides () {
      const skip = (this.page - 1) * 25
      const { data } = await this.$http.slides.get(`?_limit=25&_start=${skip}&_sort=createdAt:DESC`)
      this.slides = data.map(i => {
        return {
          ...i,
          imagen: `${host}${i.imagen.url}`
        }
      })
    },
    async deleteSlide (id) {
      if (window.confirm('¿Estas seguro de eliminar la imagen?')) {
        await this.$http.slides.delete(`/${id}`)
        this.getSlides()
      }
    },
    refresh () {
      this.showAdd = false
      this.getSlides()
    }
  },
  watch: {
    page () {
      this.getSlides()
    }
  }
}
</script>
